import { baseEnvironment } from './environment.base';

export const environment = {
  ...baseEnvironment,
  production: true,
  authUrl: 'https://auth.moveright.app',
  authClientId: 'c68f594d-6651-4da9-ab83-f4cb2ba86961',
  faAuthUrl: 'https://auth.moveright.app/oauth2/authorize',
  faClientId: 'c68f594d-6651-4da9-ab83-f4cb2ba86961',
  faClientSecret: 'BKi701asW-Ju9TX1lLNm0tDrKObGg4iPppJcPWw5kbQ',
  websocket: `ws://${ window.location.host }/api/subscriptions`,
  breakAtGraphqlErrors: false,
};
